import {
  ADD_AGENT,
  ADD_AGENT_SUCCESS,
  ADD_AGENT_FAILED,
  FETCH_AGENTS,
  FETCH_AGENTS_SUCCESS,
  FETCH_AGENTS_FAILED,
  DELETE_AGENT,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAILED,
  EDIT_AGENT,
  EDIT_AGENT_SUCCESS,
  EDIT_AGENT_FAILED,
  ADD_PP_AGENT,
  ADD_AGENT_PP_SUCCESS,
  ADD_AGENT_PP_FAILED,
    ADD_WEBSITE_AGENT,
  ADD_WEBSITE_AGENT_SUCCESS,
  ADD_WEBSITE_AGENT_FAILED
} from "../store/types";

const INITIAL_STATE = {
  agents: [],
  completed: false,
  loading: false,
  success: false,
  error: {
    flag: false,
    msg: null
  }
};

export const agentsreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_AGENT:
      return {
        ...state,
        loading: true
      };
    case ADD_AGENT_SUCCESS:
      return {
        ...state,
        agents: action.payload,
        loading: false
      };
    case ADD_AGENT_FAILED: {
      return INITIAL_STATE;
    }
       case ADD_WEBSITE_AGENT_SUCCESS:
      return {
        ...state,
        agents: action.payload,
        loading: false
      };
    case ADD_WEBSITE_AGENT_FAILED: {
      return INITIAL_STATE;
    }
    case ADD_PP_AGENT:
      return {
        ...state,
        loading: true
      };
    case ADD_AGENT_PP_SUCCESS:
      return {
        ...state,
        agents: action.payload,
        loading: false
      };
    case ADD_AGENT_PP_FAILED: {
      return INITIAL_STATE;
    }

    case FETCH_AGENTS:
      return {
        ...state,
        loading: true
      };
    case FETCH_AGENTS_SUCCESS:
      return {
        ...state,
        agents: action.payload,
        loading: false
      };
    case FETCH_AGENTS_FAILED: {
      return INITIAL_STATE;
    }
    case DELETE_AGENT:
      return {
        ...state,
        loading: true
      };
    case DELETE_AGENT_SUCCESS:
      return {
        ...state,
        agents: action.payload,
        loading: false
      };
    case DELETE_AGENT_FAILED: {
      return INITIAL_STATE;
    }
    case EDIT_AGENT:
      return {
        ...state,
        loading: true
      };
    case EDIT_AGENT_SUCCESS:
      return {
        ...state,
        agents: action.payload,
        loading: false
      };
    case EDIT_AGENT_FAILED: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};
